import { render, staticRenderFns } from "./form-step-2.vue?vue&type=template&id=3ece06c3"
import script from "./form-step-2.vue?vue&type=script&lang=js"
export * from "./form-step-2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports